import styled from "@emotion/styled";

export const List = styled.ul`
  display: flex;
  row-gap: 12px;
  column-gap: 4px;
  align-items: center;
  list-style-type: none;
  flex-wrap: wrap;
`;

export const Span = styled.span`
  padding: 4px 8px;
  background-color: ${p => p.theme.colors.background};
  border-radius: 7px;
`;

export const ListObjects = styled.ul`
  list-style-type: none;
`;
